export default function() {
    return {
        posts: [],
        fields: [
            {
                key: 'title',
                label: 'Título'
            },
            {
                key: 'status',
                label: 'Status'
            },
            {
                key: 'roles',
                label: 'Tipo de usuário'
            },
            {
                key: 'actions',
                label: 'Ações'
            }
        ],
        showDeleteConfirmationModal: false,
        deleteBanner: null,
    }
}
